module.exports = __webpack_public_path__ + "img/index24.d6603e94.png";